<template>
  <b-modal
    id="editRecurringDateModal"
    modal-class="client-details-modal payment-history"
    centered
    size="md"
    hide-footer
    hide-header-close
    no-close-on-backdrop
  >
    <template #modal-header class="modal-header-wrapper">
      <div class="text-center">
        <h6 class="mb-0">Edit Recurring Date</h6>
        <b-button
          variant="close-btn"
          class="btn-container"
          @click="closeModal"
        >
          <i class="fas fa-times"></i>
        </b-button>
      </div>
    </template>
    <b-container fluid>
      <div class="mb-3">
        <label><strong>New Bill Date :</strong></label>
        <select class="form-select mt-2" v-model="selectedDate">
          <option v-for="day in 28" :key="day" :value="day">{{ day }}</option>
        </select>
      </div>
      <div class="">
        <label><strong>Reason</strong></label>
        <span class="required-asterisk">*</span>
        <textarea class="form-control mt-2" rows="4" v-model="reason"></textarea>
      </div>

      <div class="button-wrapper">
        <button type="button" class="btn cancel-btn btn-secondary" @click="closeModal">Cancel</button>
        <b-button class="univ-btn" type="submit" @click="submitRecurringDate">
          Update
        </b-button>

      </div>
    </b-container>
  </b-modal>
</template>
<script>
import Api from "@/resource/Api";
import { mapGetters } from "vuex";

export default {
  name: "EditRecurringDateModal",

  computed: {
    ...mapGetters({
      repCode: "repId" // map repId inside this component
    })
  },

  data() {
    return {
      selectedDate: 1,
      reason: "",
    };
  },

  watch: {
    member: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.selectedDate = Number(newVal.billing_date) || 1;
          this.reason = "";
        }
      }
    }
  },

  props: {
    member: {
      type: Object,
      required: true
    }
  },

  methods: {
        closeModal() {
            this.$bvModal.hide("editRecurringDateModal");

        },

        async submitRecurringDate() {
          if (!this.reason) {
            Api.notification("error", "Please enter a reason");
            return;
          }

          const path = "v2/add-policy-billing-date";

          const payload = {
            policy_id: this.member.policy_id,
            bill_date: this.selectedDate,
            reason: this.reason,
            sendEmail: 0,
            aid: this.repCode
          };

          try {
            const response = await Api.post(path, payload);

            if (response?.data?.status === "success") {
              Api.notification(response.data.status, response.data.message);
              this.$emit("onRecurringCloseModal"); // to refresh the parent table
              this.closeModal();
            } else {
              Api.notification(response.data.status, response.data.message);
            }
          } catch (error) {
            console.error(error);
            Api.notification("error", "Failed to update recurring date");
          }
        }
    },
};
</script>
<style scoped>
.btn-container {
  cursor: pointer;
}

.button-wrapper {
  display: flex;
  justify-content: right;
  margin-top: 24px;
  gap: 16px;
  align-items: center;
}
.univ-btn , .cancel-btn{
  padding: 10px 26px;
  width: fit-content;
  font-size: 14px;
  margin: 0;
}

.form-select, .form-control {
  font-size: 14px;
}
.form-select:focus , .form-control:focus {
  outline: none;
  box-shadow: none;
  border: 1px solid #ced4da;
}
</style>
